module.exports = window["{}"];